import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import WeexImage from "../weex-ui/packages/WeexImage";
import WeexText from "../weex-ui/packages/WeexText";

Vue.config.productionTip = false;

// Register component globally
Vue.component("weex-text", WeexText);
Vue.component("weex-image", WeexImage);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.filter("percentage", function(value, decimals) {
  if (!value) {
    value = 0;
  }
  if (!decimals) {
    decimals = 0;
  }

  value = value * 100;
  return (
    Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + "%"
  );
});
